import { sumBy } from 'lodash';
import { TeamChallengeTaskProgress } from '@/src/types/JamTeamChallengeAnswer';

export const getTaskCluePointPenalty = (task: TeamChallengeTaskProgress): number => {
  const unrefundedPenalties = (task.cluePenalties || []).filter((cluePenalty) => !cluePenalty.refunded);
  return sumBy(unrefundedPenalties, (cluePenalty) => cluePenalty.penalty ?? 0);
};

export const getTaskScore = (task: TeamChallengeTaskProgress): number =>
  Math.max(0, (task.pointsEarned ?? 0) - getTaskCluePointPenalty(task));
